/* Copyright (c) 2017 Backpack Health LLC */

import { types as uiStateActionTypes } from 'redux/actions/uiState';
import { types as navigationActionTypes } from 'redux/actions/navigation';

import routeNames from 'lib/routeNames';

const initialState = {
  sidebarOpen: false,
  systemNotification: {
    message: '',
    color: '',
  },
  isWaiting: false,
  apiError: {},
  progress: 0,
  pageState: {},
  backgroundProcesses: {},
};

function getDefaultPageState(pathname) {
  switch (pathname) {
    case routeNames.profilePassword():
      return {
        isPasswordVerified: false,
      };
    default:
      return {};
  }
}

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case uiStateActionTypes.SIDEBAR_TOGGLED:
    case uiStateActionTypes.SHOW_NOTIFICATION:
    case uiStateActionTypes.DISMISS_NOTIFICATION:
    case uiStateActionTypes.CLEAR_API_ERRORS:
    case uiStateActionTypes.RECEIVE_API_ERROR:
    case uiStateActionTypes.PAGE_IS_WAITING:
    case uiStateActionTypes.UPDATE_PAGE_STATE:
      return _.assign({}, state, action.payload);
    case uiStateActionTypes.START_BACKGROUND_PROCESS:
      return {
        ...state,
        backgroundProcesses: {
          ...state.backgroundProcesses,
          [action.payload.processName]: action.payload,
        },
      };
    case uiStateActionTypes.CLEAR_BACKGROUND_PROCESS:
      const newProcess = { ...state.backgroundProcesses };
      delete newProcess[action.payload.processName];
      return {
        ...state,
        backgroundProcesses: newProcess,
      };
    case navigationActionTypes.REACT_ROUTER_LOCATION_CHANGE:
      return _.assign({}, state, {
        pageState: getDefaultPageState(action.payload.location.pathname)
      });
    default:
      return state;
  }
}

const selectors = {
  isSidebarOpen: state => state.uiState.sidebarOpen,
  isNotificationAvailable: state => !!state.uiState.systemNotification.message,
  getNotificationMessage: state => state.uiState.systemNotification.message,
  getNotificationColor: state => state.uiState.systemNotification.color,
  isPageWaiting: state => state.uiState.isWaiting,
  getPageState: state => state.uiState.pageState,
  getBackgroundProcess: (state, identifier) => state.uiState.backgroundProcesses[identifier] || null,
  getDataExportArchiveProcess: (state) => {
    const process = state.uiState.backgroundProcesses.dataExportArchive;
    return process ? process.data : null;
  },
};

export default selectors;
